import React, { useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteUserAccount } from '../../../../../store/slices/register';

const DeleteAccountConfirmation = (props) => {
    const { id } = useParams();
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { 
        postDeleteUserAccountFailure,
        postDeleteUserAccountLoading,
        postDeleteUserAccount,
     } = useSelector((state) => state?.registersReducer)

    useEffect(() => {
        if (id) {
            if (id) {
                let params = {}
                params.uid = id
                dispatch(deleteUserAccount(params))
            }
        }
    }, [])


    useEffect(() => {
        if (postDeleteUserAccountFailure || postDeleteUserAccount) {
            setTimeout(() => {
                navigate(-1)
            }, 2000)
        }
    }, [postDeleteUserAccountFailure, postDeleteUserAccount])

    return (

        <div className={"permission_denied"}>
            {(postDeleteUserAccountLoading) ?
                <>
                    {postDeleteUserAccountLoading &&
                        <>
                            <h1>Deleting Account...</h1>
                        </>
                    }
                </>
                :
                <>
                    {
                        (postDeleteUserAccount) &&
                        <div>
                            <h1>Deleted SuccessFully</h1>
                            <h5>Thank You!</h5>
                        </div>
                    }
                    {
                        (postDeleteUserAccountFailure) &&
                        <div className='text-danger'>
                            <h1>Deletion Failed</h1>
                            <h5>Please Try Again</h5>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default DeleteAccountConfirmation